export default __webpack_public_path__ + "static/A02-cf61dc0e8951f1e525e52cd67a67947a.jpg";